export const comments_5150487 = {"data":{"data":[],"links":{}}}